import { render } from "./Home.vue?vue&type=template&id=a564b926"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=a564b926&lang=scss"
script.render = render

export default script